import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Product, ProductOffering} from '@uofu-uss-aux/software-catalog-ng-core';
import {orderBy} from 'lodash-es';
import {ProductOfferingComponent} from '../product-offering/product-offering.component';
import {LicenseDescriptionComponent} from './license-description/license-description.component';
import {NgForOf, NgIf} from '@angular/common';

@Component({
  selector: 'app-product-details-by-license',
  templateUrl: './product-details-by-license.component.html',
  styleUrls: ['./product-details-by-license.component.scss'],
  standalone: true,
  imports: [
    ProductOfferingComponent,
    LicenseDescriptionComponent,
    NgIf,
    NgForOf,
  ]
})
export class ProductDetailsByLicenseComponent {

  @Input()
  offerings: ReadonlyArray<ProductOffering>;
  @Input()
  licenseTitle = '';
  @Input()
  product: Product;
  @Output()
  addToCartEmitter = new EventEmitter<ProductOffering>();

  constructor() {
  }

  get hasOfferings(): boolean {
    return this.offerings && this.offerings.length > 0;
  }

  getSortedOfferings(): ReadonlyArray<ProductOffering> {
    return orderBy(this.offerings, ['version', 'platform.title', 'usageType'], ['desc', 'desc', 'desc']);
  }

  article(): string {
    return (this.licenseTitle === 'Employee') ? 'an' : 'a';
  }

  addToCart(offering: ProductOffering) {
    this.addToCartEmitter.emit(offering);
  }

}
